import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from './Icons';
import { Modal } from './Modal';
import { navigation } from '../lib/data';
import { useDialog } from '../contexts/DialogContext';

export const Header: React.FC<{ waitlistMode?: boolean }> = ({ waitlistMode = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { activeDialog, openDialog } = useDialog();

  // Hide header on mobile when any dialog is open
  const shouldHideOnMobile = activeDialog !== null;

  return (
    <header className={`absolute inset-x-0 top-0 z-50 ${shouldHideOnMobile ? 'hidden sm:block' : ''}`}>
      <nav aria-label="Global" className="flex items-center justify-between p-6 lg:px-8">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">BrandedMark</span>
            {/* Desktop logo */}
            <img
              alt="BrandedMark Logo"
              src="/img/logo-full.png"
              className="hidden sm:block h-24 w-auto"
            />
            {/* Mobile logo */}
            <img
              alt="BrandedMark Logo"
              src="/img/logo-compact.png"
              className="block sm:hidden h-12 w-auto"
            />
          </Link>
        </div>
        {!waitlistMode && navigation.length > 0 && (
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" />
            </button>
          </div>
        )}
        {!waitlistMode && (
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => {
              if (item.href.startsWith('/') && !item.href.startsWith('/#')) {
                return (
                  <Link key={item.name} to={item.href} className="text-sm/6 font-semibold text-gray-900 hover:text-gray-600 transition-colors">
                    {item.name}
                  </Link>
                );
              }
              return (
                <a key={item.name} href={item.href} className="text-sm/6 font-semibold text-gray-900 hover:text-gray-600 transition-colors">
                  {item.name}
                </a>
              );
            })}
          </div>
        )}
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <button
            onClick={() => openDialog('waitlist')}
            className="rounded-md px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:opacity-90"
            style={{ backgroundColor: '#241E61' }}
          >
            Join Waitlist
          </button>
        </div>
      </nav>

      {/* Mobile menu modal - only shown on small screens */}
      <Modal isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
        <div className="flex items-center justify-between mb-6">
          <Link to="/" className="-m-1.5 p-1.5" onClick={() => setMobileMenuOpen(false)}>
            <span className="sr-only">BrandedMark</span>
            <img
              alt="BrandedMark Logo"
              src="/img/logo-compact.png"
              className="h-12 w-auto"
            />
          </Link>
          <button
            type="button"
            onClick={() => setMobileMenuOpen(false)}
            className="-m-2.5 rounded-md p-2.5 text-gray-700 hover:text-gray-900"
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
        <div className="flow-root">
          <div className="divide-y divide-gray-200">
            <div className="space-y-1 pb-6">
              {navigation.map((item) => {
                if (item.href.startsWith('/') && !item.href.startsWith('/#')) {
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="block rounded-lg px-3 py-3 text-base font-semibold text-gray-900 hover:bg-gray-50 transition-colors"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  );
                }
                return (
                  <a
                    key={item.name}
                    href={item.href}
                    className="block rounded-lg px-3 py-3 text-base font-semibold text-gray-900 hover:bg-gray-50 transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.name}
                  </a>
                );
              })}
            </div>
            <div className="pt-6">
              <button
                onClick={() => {
                  setMobileMenuOpen(false);
                  openDialog('waitlist');
                }}
                className="block w-full rounded-lg px-3 py-3 text-base font-semibold text-white transition-all text-center"
                style={{ backgroundColor: '#241E61' }}
              >
                Join Waitlist
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </header>
  );
};
